<p-toast></p-toast>
<div class="card header-box" reflow="true">
    <form [formGroup]="formData" (ngSubmit)="getApplicationStatus()">
        <div class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
            <div class="field md:col-4 col-12">
                <label for="name">{{'Enter Aadhar No. to check past subsidy' | translate}}</label>
                <input maxlength="12" pattern="^[0-9]{12}$" pKeyFilter="int" formControlName="aadharNo" pInputText
                    id="name" type="text" autofocus
                    [ngClass]="{ 'ng-invalid ng-dirty': formDataControls['aadharNo'].invalid && formDataControls['aadharNo'].touched }" />

                <div *ngIf="formDataControls['aadharNo'].invalid && formDataControls['aadharNo'].touched"
                    class="invalid-feedback">
                    <div *ngIf="formDataControls.aadharNo.errors.required">{{'AADHAR_NO_IS_REQUIRED' | translate}}</div>
                    <div *ngIf="formDataControls.aadharNo.errors.minlength">{{'AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS' |
                        translate}}</div>
                    <div *ngIf="formDataControls.aadharNo.errors.maxlength">{{'AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS' |
                        translate}}</div>
                    <div *ngIf="formDataControls.aadharNo.errors.pattern">{{'AADHAR_NO_SHOULD_CONTAIN_ONLY_DIGITS' |
                        translate}}</div>
                </div>
            </div>
        </div>
        
        <div class="flex flex-wrap align-items-center justify-content-center mt-2">
            <button pButton pRipple label="{{'Get Details'| translate}}" class="p-button-success mx-4"
                type="submit"></button>
            <button pButton pRipple label="{{'Clear'| translate}}" class="p-button-secondary mx-4"
                (click)="onClear()"></button>
        </div>
    </form>
    <!-- <div class="flex flex-wrap align-items-center justify-content-center">
        <div class="field">
            <label for="name" class="mr-6">{{'Enter Aadhar No. to check past subsidy'| translate}}</label>
            <input type="text" pInputText id="name" [(ngModel)]="inputId" required autofocus />
        </div>
    </div>
    <div class="flex flex-wrap align-items-center justify-content-center mt-5">
        <button pButton pRipple label="{{'GET_DETAILS'| translate}}" class="p-button-success"
            (click)="getApplicationStatus()"></button>
    </div> -->
</div>

<div class="card mt-2" *ngIf="farmerPreviousSubsidies && isSubmitted" reflow="true">
    <div class="grid p-fluid">
        <div class="field col-12">
            <label htmlFor="state" class="bold">{{'CURRENT_APPLICATION_SUBSIDY_DEPARTMENT' | translate}}</label>
            <p-table [value]="farmerPreviousSubsidies" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{'APP_ID' | translate}}</th>
                        <th>{{'FARMER_NAME' | translate}}</th>
                        <th>{{'DEPARTMENT' | translate}}</th>
                        <th>{{'AREA' | translate}}</th>
                        <th>{{'SUBSIDY_YEAR' | translate}}</th>
                        <th>{{'AADHAR_NUMBER' | translate}}</th>
                        <th>{{'SYSTEM' | translate}}</th>
                        <th>{{'LAND_DETAILS' | translate}}</th>
                        <th>{{'DIFF_YEAR' | translate}}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-subsidy>
                    <tr>
                        <td>{{ subsidy.AppId }}</td>
                        <td>{{ subsidy.FarmerName }}</td>
                        <td>{{ subsidy.Department }}</td>
                        <td>{{ subsidy.Area | number: "1.2-2" }}</td>
                        <td>{{ subsidy.SubsidyYear }}</td>
                        <td>{{ subsidy.AadharNo }}</td>
                        <td>{{ subsidy.System }}</td>
                        <td>{{ subsidy.LandDetail }}</td>
                        <td>{{ subsidy.DiffYear }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="10">{{'NO_RECORDS_TO_SHOW' | translate}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>